import { useSendProductRequest } from '@/application/send-product-request'
import { useAppSelector } from '@/redux/hooks'
import { Base, Modal, SuccessIcon } from '@itsrever/design-system'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
interface MainFeatureProps {
  layout: React.ReactNode
  title: string
  subtitle: string
  description: string
  image: string
}
export const MainFeature: React.FC<MainFeatureProps> = ({
  layout,
  title,
  subtitle,
  description,
  image
}) => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const email =
    useAppSelector((store) => store.userApi.getMe.response.user?.name) ?? ''
  const { sendProductRequest, isLoading, error, success } =
    useSendProductRequest()

  const handleClickRequest = () => {
    sendProductRequest({
      email,
      featureText: title,
      source: 'store'
    })
  }

  return (
    <>
      <div className="group relative aspect-square size-[300px] shrink-0 overflow-hidden rounded-xl bg-white p-4 shadow transition-all hover:shadow-lg">
        <div className="absolute bottom-0 left-0 z-50 flex size-full h-0 items-center justify-center text-white backdrop-blur-sm transition-all duration-500 group-hover:h-[200px]">
          <p
            className="hidden cursor-pointer rounded-full bg-white/10 px-3 py-1 text-base font-semibold shadow-sm transition-all hover:scale-105 hover:shadow group-hover:block"
            style={{
              backgroundColor: '#1790FF'
            }}
            onClick={() => setIsModalOpen(true)}
          >
            More information
          </p>
        </div>
        {layout}
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        closeButton={true}
      >
        <div className="p-3">
          <p className="font-logo text-4xl uppercase text-gray-700">{title}</p>
          <p className="mt-1 text-xl font-semibold leading-5">{subtitle}</p>
          <div className="mt-12 flex gap-6">
            <img className="h-56" src={image} />
            <div className="flex flex-col justify-between">
              <p
                className="text-base font-thin"
                dangerouslySetInnerHTML={{
                  __html: description
                }}
              />
              <div className="mb-8 mt-12 h-16 w-full">
                {isLoading ? (
                  <div className="flex w-full items-center justify-center">
                    <Base.Spinner
                      label={t('rever_store.sending_request')}
                      className="m-2 mt-4"
                    />
                  </div>
                ) : success ? (
                  <div className="flex w-full items-center justify-center">
                    <SuccessIcon className="-ml-2 mr-4 size-6" />
                    <p className="text-sm font-thin text-gray-400">
                      Request sent.
                      <br />
                      Your account manager will contact you soon with more
                      information about the pricing.
                    </p>
                  </div>
                ) : error ? (
                  <div className="flex w-full items-center justify-center">
                    <p className="text-sm font-thin text-red-500">
                      Something went wrong. Please try again.
                    </p>
                  </div>
                ) : (
                  <p
                    onClick={handleClickRequest}
                    className="mx-auto w-fit cursor-pointer rounded-full px-6 py-1 text-base font-semibold text-white shadow-sm transition-all hover:scale-105 hover:shadow"
                    style={{
                      backgroundColor: '#1790FF'
                    }}
                  >
                    Request access
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
export default MainFeature
